import { render, staticRenderFns } from "./PersonProfileRecentNotesOverviewRow.vue?vue&type=template&id=301b994c&scoped=true&"
import script from "./PersonProfileRecentNotesOverviewRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileRecentNotesOverviewRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileRecentNotesOverviewRow.vue?vue&type=style&index=0&id=301b994c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301b994c",
  null
  
)

export default component.exports